import CardTournament from './CardTournament';

export default CardTournament;
